export const API_URL = 'https://psp.com.ph/api';
// export const API_URL = 'http://psp.com.ph/'
// export const API_URL = 'http://localhost/api'
// export const API_URL = 'http://localhost:90/api'
